import { HttpInterceptorFn } from '@angular/common/http';

export const ngrokInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('ngrok-free.app')) {
    return next(req);
  }

  const ngrokReq = req.clone({
    setHeaders: {
      'ngrok-skip-browser-warning': 'true',
    },
  });

  return next(ngrokReq);
};
